export enum Insertion {
  UserName = '##UserName##',
  UserEmail = '##Email##',
  SiteHome = '##SiteHome##',
  SiteName = '##SiteName##',
  ApplicationName = '##ApplicationName##',
  RoomName = '##RoomName##',
  DocumentName = '##DocumentName##',
  DocumentType = '##DocumentType##',
  DocumentLink = '##DocumentLink##',
  RecordLink = '##RecordLink##',
  WorkflowReviewStage = '##WorkflowReviewStage##',
  Issues = '##Issues##',
  ReviewComments = '##ReviewComments##',
  WorkflowName = '##WorkflowName##',
  Reviewer = '##Reviewer##',
  Phone = '##Phone##',
  LinkedServers = '##LinkedServers##',
  InvestigativeSite = '##InvestigativeSite##',
  Contact = '##Contact##',
  ReturnedBy = '##ReturnedBy##',
  MyReviewsLink = '##MyReviewsLink##',
  AuditComments = '##AuditComments##',
  AuditorEmail = '##AuditorEmail##',
  AuditorName = '##AuditorName##',
  AuditorPhone = '##AuditorPhone##',
  AuditProfile = '##AuditProfile##',
  VisitDate = '##VisitDate##',
  VisitType = '##VisitType##',
  VisitSummary = '##VisitSummary##',
  Comments = '##Comments##',
  NotApplicableDocuments = '##NotApplicableDocuments##',
  DocumentsMissingInISF = '##DocumentsMissingInISF##',
  VerifiedDocuments = '##VerifiedDocuments##',
  CRAUserFullName = '##CRAUserFullName##',
  QueryId = '##QueryID##',
  DocumentId = '##DocumentID##',
  FileName = '##FileName##',
  DocumentTitle = '##DocumentTitle##',
  FormType = '##FormType##',
  RecordId = '##RecordId##',
  RecordName = '##RecordName##',
  RecordType = '##RecordType##',
  RecordStatus = '##RecordStatus##',
  RecordUrl = '##RecordUrl##',
  SenderEmail = '##SenderEmail##',
  SenderPhone = '##SenderPhone##',
  WorkflowStage = '##WorkflowStage##',
  NotificationSubject = '##NotificationSubject##',
}
